/* eslint-disable react/display-name */
import React, { useEffect, useMemo, useState, forwardRef, useImperativeHandle } from 'react';
import { isEqual } from 'lodash';

// import FilterRow from './FilterRow';
import { useSummariesContext } from '../../context/SummariesUIContext';
import { UIHelpers } from '../../../../../constants/pages/UIHelpers';
import { getObjectUrl, prepareFilter, setOrDeleteParams } from '../../../../../helpers';
import { useHistory } from 'react-router';
import propertiesToFilter from '../../../../../constants/movements/filters/propertiesToFilter';
import { FiltersSection } from '../../../../../components';
import SUmmariesFiltersModal from './SummariesFiltersModal';

// UI Helpers
const { initialFilter } = UIHelpers();

const initialLabel = [{ id: 0, property: { type: 'text', label: '' }, value: '' }];
const defaultUserSearchText = {
    code: '',
    id_creditcard_movement_type: '',
    merchant_description: ''
};

const SummariesCustomFilters = forwardRef((props, ref) => {
    const summariesUIContext = useSummariesContext();
    const summariesUIProps = useMemo(() => {
        return {
            isLoading: summariesUIContext.isLoading,
            setIsLoading: summariesUIContext.setIsLoading,
            queryParams: summariesUIContext.queryParams,
            setQueryParams: summariesUIContext.setQueryParams,
        };
    }, [summariesUIContext]);
        // States

    // input search state
    const [search, setSearch] = useState('');

    const [filtersList, setFiltersList] = useState(initialLabel);
    const [date, setDate] = useState([]);

    const [searchText, setSearchText] = useState(defaultUserSearchText);
    // Modal state filter
    const [showFiltersDialog, setShowFiltersDialog] = useState(false);
    // Const
    const typesToFilter = propertiesToFilter;
    const propertiesToLike = ['id_statement', 'last_four', 'document'];

    // URL Search Params
    const params = new URLSearchParams(window.location.search);
    // This is so that the url can be updated after there are changes in the table props
    // Hooks
    const history = useHistory();

    // Reset
    const reset = () => {
        history.push(`${window.location.pathname}`);
        initialFilter.url = window.location.pathname;
        summariesUIProps.setQueryParams(initialFilter);
        setFiltersList(initialLabel);
        setSearch('');
        setDate([]);
    };
    useImperativeHandle(ref, () => ({
        reset
    }));

    // Handlers
    const handleCleanFilters = () => {
        history.push(`${window.location.pathname}`);
        initialFilter.url = window.location.pathname;
        summariesUIProps.setQueryParams(initialFilter);
        setFiltersList([{ id: 0, property: { type: 'text', label: '' }, value: '' }]);
        setDate([]);
    };
    const handleSearch = () => {
        // URL
        // OnClick URL and useContext is updating
        changeURL(filtersList);
        // handleFilterSearch with 1 to reset number page
        handleFilterSearch(filtersList, { dateFrom: date[0], dateTo: date[1] }, search);

        // close modal
        setShowFiltersDialog(false);
    };

    const handleFilterSearch = (filters, dates, inputText) => {
        const sortedFilters = filters.length && filters.sort((filter1, filter2) => {
            if (filter1.property.isIndexed) {
                return -1;
            }
            if (filter2.property.isIndexed) {
                return 1;
            }
            return 0;
        });

        // Prepare filter 'search'
        const newQueryParams = prepareFilter(summariesUIProps.queryParams, sortedFilters, dates, 'emision_date');
        propertiesToLike.forEach(property => {
            if (inputText) newQueryParams.filters.like(property, `${inputText}`);
        });

        // Search activated with filter changes
        const searchPressed = !isEqual(newQueryParams, summariesUIProps.queryParams);

        if (searchPressed) {
            newQueryParams.pageNumber = 1;
            newQueryParams.url = window.location.href;
            // update list by queryParams
            summariesUIProps.setQueryParams(newQueryParams);
        }
    };

    // Add filter 'search' into params
    const searchInputText = (params) => {
        setOrDeleteParams(params, 'search', search);
    };

    // 1) Desde la url lleno los estados
    const uniqueFilter = () => {
        const url = getObjectUrl(params, { ...searchText, search: '' }, { ...defaultUserSearchText, search: '' });
        url.dateFrom
            ? setDate([url.dateFrom, url.dateTo])
            : setDate([]);

        url.dateTo
            ? setDate([url.dateFrom, url.dateTo])
            : setDate([]);
        // For input 'search'
        url.search !== undefined ? setSearch(url.search) : setSearch('');
        const inputText = url.search ? url.search : '';
        // For modal
        const filterListUpdated = getFilterListByURL(url);
        const newInitialLabel = [...initialLabel];
        setFiltersList(filterListUpdated.length ? filterListUpdated : newInitialLabel);

        // apply filters
        handleFilterSearch(filterListUpdated, { dateFrom: url.dateFrom, dateTo: url.dateTo }, inputText);
    };

    const getFilterListByURL = (url) => {
        const list = [];
        let i = 0;

        for (const key in defaultUserSearchText) {
            if (Object.hasOwnProperty.call(searchText, key)) {
                if (!url[key]) { continue; };
                // if (url[key] === undefined) { continue; };
                url[key] && setSearchText({ ...searchText, [key]: url[key] });

                const filter = {};
                filter.id = i;
                const obj = typesToFilter.find(type => type.value.label === key);
                filter.property = obj.value;

                if (filter.property.type === 'text') {
                    filter.value = url[key];
                }

                if (filter.property.type === 'select') {
                    const datos = obj.value.data.find(data => data.value.id === Number(url[key]) || data.value.id === (url[key]));
                    filter.value = datos?.value;
                }

                list.push(filter);
            }
            i++;
        }
        if (!list.length) return [{ id: 0, property: { type: 'text', label: '' }, value: '' }];
        return list;
    };

    // *** URL ***
    // 2) se usa cuando se cambian el orden o el tamaño de la paginación y cuando apreto el botón buscar
    // URL is updating from states and usersUIProps (useContext)
    const changeURL = (filters) => {
        // set or delete Dates
        setOrDeleteParams(params, 'dateFrom', date[0]);
        setOrDeleteParams(params, 'dateTo', date[1]);

        // set fiters by sortOder, sortField, pageNumber and pageSize
        for (const key in summariesUIProps.queryParams) {
            if (key === 'url' || key === 'filters') continue;
            setOrDeleteParams(params, key, summariesUIProps.queryParams[key]);
        };

        // Deleted old filter queries
        for (const key in defaultUserSearchText) {
            if (Object.hasOwnProperty.call(searchText, key)) {
                params.delete(key);
            }
        }

        // set filter queries
        for (let i = 0; i < filters.length; i++) {
            const element = filters[i];
            const valueToFilter = element.property.type === 'select' ? element.value?.id : element.value;
            setOrDeleteParams(params, element.property.label, valueToFilter);
        }
        searchInputText(params);
        updatePath(params);
    };

    const updatePath = (params) => {
        history.push(`${window.location.pathname}?${params.toString()}`);
    };

    // URL is read for the only time when starting the component
    // then handleFilterSearch users and update states
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => uniqueFilter(), [window.location.href]);

    const toggleFiltersDialog = () => setShowFiltersDialog(!showFiltersDialog);
    // Main Component

    return (
        <>
            {/* Modal filters */}
            <SUmmariesFiltersModal
                open={showFiltersDialog}
                onClose={() => setShowFiltersDialog(false)}
                date={date}
                setDate={setDate}
                handleSearch={handleSearch}
                handleCleanFilters={handleCleanFilters}

            />
            <FiltersSection
                searchText={search}
                handleChangeSearchText={setSearch}
                applyFilter={handleSearch}
                toggleFiltersDialog={toggleFiltersDialog}
                UIProps={summariesUIProps}
                disableButton={summariesUIProps.isLoading}
            />
        </>
    );
});
export default SummariesCustomFilters;
